import {
  getAccountableTeamFromJobOrder,
  isSuperUser,
  isUserInAccountableTeam
} from 'features/sendouts/common/accountability';
import { COLLABORATOR_SCOPE } from 'features/sendouts/common/constants';
import { useUserContext } from 'providers/UserProvider';

export const useSendoutCreationAccountability = (jobOrder = {}) => {
  const [currentUser] = useUserContext();

  const accountableTeam = getAccountableTeamFromJobOrder(jobOrder);
  const canUserCreateSendout =
    isUserInAccountableTeam({
      accountableTeam,
      user: currentUser,
      collaboratorScope: COLLABORATOR_SCOPE.Any
    }) || isSuperUser(currentUser);

  return { canUserCreateSendout };
};
